module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/69.91b7ea4b.png";